import { h, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import TwoFactorMethod from '../TwoFactorMethod.js';
import TwoFactorFrequency from '../TwoFactorFrequency.js';
import TwoFactorPhone from '../TwoFactorPhone.js';
import TwoFactorBackupEmail from '../TwoFactorBackupEmail.js';
import TwoFactorLogin from '../TwoFactorLogin.js';

// import FetchAccountInfo from '../FetchAccountInfo.js';
import Button from '../Button.js';

class TwoFactorSettings extends Component {
	state = {
		verified: false,
		showCode: false
	}

	updateState = (key, value) => {
		switch (key) {
			case 'method':
				this.setState({ method: value });
				break;
			case 'country':
				this.setState({ country: value });
				break;
			case 'countryCode':
				this.setState({ countryCode: value });
				break;
			case 'frequency':
				this.setState({ frequency: value });
				break;
			case 'newPhone':
				this.setState({ newPhone: value });
				break;
			case 'newEmail':
				this.setState({ newEmail: value });
				break;
		}
	}

	cancel2FAUpdate = () => {
		route('/security', true);
	}

	fetchTwoFactorInfo = (webToken) => {
		fetch('https://api.hirezstudios.com/acct/twoFactorInfo', {
  		method: 'post',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${webToken}"}`
    	}).then((response) => response.json()).then((response) => {
				this.setState({
					twoFactorData: response,
					method: response.validationOption.toLowerCase(),
					frequency: response.validationPeriod.toLowerCase(),
					oldPhone: response.phone === null ? '' : response.phone
				});
				
    	});
	}

	prepareData = () => {
		this.setState({
			notifyBySms: undefined,
			notifyByEmail: undefined
		});
		switch (this.state.method) {
			case 'phone':
				this.setState({ notifyBySms: true });
				break;
			case 'email':
				this.setState({ notifyByEmail: true });
				break;
			case 'both':
				this.setState({ notifyBySms: true, notifyByEmail: true });
				break;
			default:
				return false;
		}
		switch (this.state.frequency) {
			case 'none':
				this.setState({ validationPeriod: 0 });
				break;
			case 'periodic':
				this.setState({ validationPeriod: 1 });
				break;
			case 'everytime':
				this.setState({ validationPeriod: 2 });
				break;
			default:
				return false;
		}
		return true;
	}

	validateUpdate = () => {
		this.setState({ errorMessage: undefined });
		if (!this.state.method) {
			this.setState({ errorMessage: 'A notification method is required to update two factor settings.' });
			return false;
		}
		if (!this.state.frequency) {
			this.setState({ errorMessage: 'A notification frequency is required to update two factor settings.' });
			return false;
		}
		if (this.state.method === 'phone') {
			if (!this.state.newPhone) {
				if (!this.state.oldPhone) {
					this.setState({ errorMessage: 'A phone number must be associated with your account to use the phone notification method.' });
					return false;
				}
			}
		}
		return true;
	}

	update2FASettings = () => {
		this.setState({ buttonUpdate2FA: 'loading' });
		if (this.validateUpdate()) {
			if (this.prepareData()) {
				fetch('https://api.hirezstudios.com/acct/twoFactorOptIn', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "notifyBySms": "${this.props.notifyBySms}", "notifyByEmail": "${this.state.notifyByEmail}", "validationPeriod": "${this.state.validationPeriod}"}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ buttonUpdate2FA: 'initial' });
					if (response.statusCode === 200) {
						route('/two-factor-confirm', true);
					}
					else {
						this.setState({ errorMessage: 'Something went wrong. Please try again.' });
					}
				});
			}
			else {
				this.setState({ buttonUpdate2FA: 'initial' });
			}
		}
		else {
			this.setState({ buttonUpdate2FA: 'initial' });
		}
	}

	shouldComponentUpdate(nextProps) {
		if (this.state.twoFactorData === undefined && nextProps.userData.webToken !== null) {
			this.fetchTwoFactorInfo(nextProps.userData.webToken);
		}
	}

	componentDidMount() {
		window.scrollTo(0,0);
		this.fetchTwoFactorInfo(this.props.userData.webToken);
	}

	componentWillUnmount() {
		this.setState({ verified: false });
	}

	// TODO: expose webToken to TwoFactorPhone as webToken prop via Context from AccountInfo
	// TODO: expose accountEmail and webToken to TwoFactorBackupEmail via Context from AccountInfo

	render() {
		const { t } = this.props;
		if (this.state.verified === false) {
			return (
				<div className="view-two-factor">
					<h1>{t('Security')}</h1>
					<TwoFactorLogin userData={this.props.userData} callback={() => this.setState({ verified: true })} />
				</div>
			);
		}
		return (
			<div className="view-two-factor">
				<h1>{t('Security - Two Factor Authentication')}</h1>
				<TwoFactorMethod update={this.updateState} twoFactorData={this.state.twoFactorData} />
				<TwoFactorFrequency update={this.updateState} twoFactorData={this.state.twoFactorData} />
				{(this.state.method === 'phone' || this.state.method === 'both') && this.state.country !== 'other' &&
					<TwoFactorPhone userData={this.props.userData} country={this.state.country} countryCode={this.state.countryCode} update={this.updateState} twoFactorData={this.state.twoFactorData} />
				}
				{(this.state.method ==='email' || this.state.method === 'both') &&
					<TwoFactorBackupEmail userData={this.props.userData} update={this.updateState} twoFactorData={this.state.twoFactorData} />
				}
				<div className="buttons-wrapper save-settings">
					<Button
						color="blue"
						copy={t('Save')}
						state={this.state.buttonUpdate2FA}
						onClick={this.update2FASettings}
					/>
					<Button
						copy={t('Cancel')}
						onClick={this.cancel2FAUpdate}
					/>
        </div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(TwoFactorSettings);


// WEBPACK FOOTER //
// ./components/views/TwoFactorSettings.js